import hljs from 'highlight.js/lib/core.js'
import "highlight.js/styles/atom-one-dark.css";
import javascript from 'highlight.js/lib/languages/javascript'
import python from 'highlight.js/lib/languages/python'
import r from 'highlight.js/lib/languages/r'
import bash from 'highlight.js/lib/languages/bash'

export default function () {
    hljs.registerLanguage('javascript', javascript);
    hljs.registerLanguage('python', python);
    hljs.registerLanguage('r', r);
    hljs.registerLanguage('bash', bash);
    hljs.initHighlighting();
}

